export default __webpack_public_path__ + "static/SOSWEET_GREEN-5dff0f66e577ca39c0cdb1799c49e21f.png";